import React from 'react';
import { TypedMemo } from '../../../common/types';
import { LoadingView } from '../../../common/views/LoadingView';
import { useAccountId } from '../../../../redux/slices/appInfo/hooks';
import { ReleasesList } from './list/ReleasesList';

/**
 * The Promote / Releases route (`/app/promote`, spec D25, design m1). Every call is account-scoped;
 * the key starts a new list for each artist.
 */
const ReleasesListScreenComponent: React.FC = () => {
  const accountId = useAccountId();

  if (accountId === null) {
    return <LoadingView />;
  }

  return <ReleasesList key={accountId} accountId={accountId} />;
};

export const ReleasesListScreen = TypedMemo(ReleasesListScreenComponent);
